import styled from 'styled-components';

export const TodoListContainer = styled.div`
    background: rgba(0, 0, 0, 0.6);
    backdrop-filter: blur(10px);
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    padding: 2px 0;
    overflow-y: ${props => props.limitColumnHeight ? 'auto' : 'visible'};
    
    &::-webkit-scrollbar {
        width: 8px;
    }

    &::-webkit-scrollbar-track {
        background: rgba(255, 255, 255, 0.05);
        border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb {
        background: rgba(255, 255, 255, 0.2);
        border-radius: 4px;
        
        &:hover {
            background: rgba(255, 255, 255, 0.3);
        }
    }
`;

export const TodoHeader = styled.div`
  display: flex;
  padding: 0 24px;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${props => props.isCollapsed ? '0' : '16px'};
`;

export const Title = styled.h3`
  margin: 0;
  color: #fff;
  font-size: 16px;
  font-weight: 500;
`;

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const TodoFormHeader = styled.div`
  width: 100%;
  padding: 0 24px;
`;

export const TodoInput = styled.input`
  width: 100%;
  padding: 8px 12px;
  border: 2px solid #dfe1e6;
  border-radius: 3px;
  font-size: 14px;
  margin-bottom: 12px;
  background: transparent;
  color: #fff;

  &:focus {
    border-color: #4c9aff;
    outline: none;
    box-shadow: 0 0 0 1px #4c9aff;
  }

  &::placeholder {
    color: #ccc;
  }
`;

export const Progress = styled.div`
  height: 4px;
  background: #ebecf0;
  border-radius: 2px;
  margin: 12px 0;
  overflow: hidden;
  margin: 0 24px;
`;

export const ProgressBar = styled.div`
  height: 100%;
  background: ${props => props.percentage === 100 ? '#36B37E' : '#4c9aff'};
  width: ${props => props.percentage}%;
  transition: width 0.2s ease;
`;

export const TodoItemWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 0;
  width: 100%;
`;

export const ConvertAllButton = styled.button`
  background: transparent;
  color: #fff;
  border: none;
  border-radius: 3px;
  padding: 6px 12px;
  font-size: 13px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all 0.2s ease;

  &:hover {
    background: #ebecf0;
    color: #0079bf;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const TodoCount = styled.span`
  color: #fff;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 4px;

  &::before {
    content: '✓';
    font-size: 12px;
    color: ${props => props.completed ? '#36B37E' : '#fff'};
  }
`;

export const TodoOptions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const ToggleButton = styled.button`
  background: transparent;
  color: #fff;
  border: none;
  border-radius: 3px;
  padding: 6px 12px;
  font-size: 13px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all 0.2s ease;

  &:hover {
    background: #ebecf0;
    color: #172b4d;
  }

  svg {
    width: 14px;
    height: 14px;
  }
`;

export const CollapseButton = styled.button`
  background: transparent;
  border: none;
  color: #fff;
  cursor: pointer;
  padding: 8px;
  border-radius: 3px;
  display: flex;
  align-items: center;
  margin-left: 16px;

  &:hover {
    background: rgba(9, 30, 66, 0.08);
  }
`;

export const TodoContent = styled.div`
  display: ${props => props.isCollapsed ? 'none' : 'block'};
  padding-bottom: 16px;
  @media (max-width: 768px) {
    overflow-y: auto;
    height: calc(100vh - 41px);
  }
`;
